import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { NgxSpinnerService } from 'ngx-spinner';
import { MessageService } from 'primeng/api';
import { Candidato } from 'src/app/models/candidato.model';
import { CandidatosCsvDTO } from 'src/app/models/candidatosCsvDTO.model';
import { CanditadosService } from 'src/app/services/canditados.service';
import { formatDate, Location } from '@angular/common';
import { Utils } from 'src/app/utils/utils';
import * as moment from 'moment';
import { Router } from '@angular/router';
import { Candidatura } from 'src/app/models/candidatura.model';
import { CandidaturaService } from 'src/app/services/candidatura.service';

declare var window: any;
@Component({
  selector: 'app-candidaturasNav',
  templateUrl: './candidaturanav.component.html',
  styleUrls: ['./candidaturanav.component.css']
})
export class CandidaturaNavComponent implements OnInit {
 
  constructor(
    protected messageService: MessageService,
    protected candidaturaService: CandidaturaService,
    protected formBuilder: FormBuilder,
    public utils: Utils,
 
    
    ) { }

  ngOnInit() {
   
 
  }

  

}